// Wire shape: kebab-case strings matching BloodGlucoseFormContextApiDtoV1 on the backend.
export const bloodGlucoseFormContexts = [
  "fasting",
  "snack-before-breakfast",
  "breakfast",
  "snack-between-breakfast-and-lunch",
  "lunch",
  "snack-between-lunch-and-dinner",
  "dinner",
  "snack-after-dinner",
  "quick-check",
] as const

export type BloodGlucoseFormContextApiDto = (typeof bloodGlucoseFormContexts)[number]
export type BloodGlucoseFormContext = BloodGlucoseFormContextApiDto

export const textForFormContext = (context: BloodGlucoseFormContext): string => {
  switch (context) {
    case "fasting":
      return "Fasting"
    case "breakfast":
      return "Breakfast"
    case "lunch":
      return "Lunch"
    case "dinner":
      return "Dinner"
    case "snack-before-breakfast":
    case "snack-between-breakfast-and-lunch":
    case "snack-between-lunch-and-dinner":
    case "snack-after-dinner":
      return "Snack"
    case "quick-check":
      return "Quick check"
  }
}
